// extracted by mini-css-extract-plugin
export default {"sideMenu":"SideMenu_sideMenu__Xb7C7","open":"SideMenu_open__ztosI","nav":"SideMenu_nav__DONYJ","navLink":"SideMenu_navLink__-0aTw","backdrop":"SideMenu_backdrop__1gMWe"};